/**
 * File generated by js-routes 2.0.6
 * Based on Rails 6.1.3.2 routes of SpuModulos::Application
 */
const __jsr = ((that) => {
    const hasProp = (value, key) => Object.prototype.hasOwnProperty.call(value, key);
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const Root = that;
    const ModuleReferences = {
        CJS: {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            define: (routes) => (module.exports = routes),
            support: () => typeof module === "object",
        },
        AMD: {
            define: (routes) => 
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            define([], function () {
                return routes;
            }),
            support: () => typeof define === "function" && !!define.amd,
        },
        UMD: {
            define: (routes) => {
                if (ModuleReferences.AMD.support()) {
                    ModuleReferences.AMD.define(routes);
                }
                else {
                    if (ModuleReferences.CJS.support()) {
                        try {
                            ModuleReferences.CJS.define(routes);
                        }
                        catch (error) {
                            if (error.name !== "TypeError")
                                throw error;
                        }
                    }
                }
            },
            support: () => ModuleReferences.AMD.support() || ModuleReferences.CJS.support(),
        },
        ESM: {
            define: () => null,
            support: () => true,
        },
    };
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const DeprecatedGlobbingBehavior = false;
    const UriEncoderSegmentRegex = /[^a-zA-Z0-9\-._~!$&'()*+,;=:@]/g;
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
    ];
    class UtilsClass {
        constructor() {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "_options",
                serializer: null || this.default_serializer.bind(this),
            };
        }
        default_serializer(value, prefix) {
            if (this.is_nullable(value)) {
                return "";
            }
            if (!prefix && !this.is_object(value)) {
                throw new Error("Url parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                for (const element of value) {
                    result.push(this.default_serializer(element, prefix + "[]"));
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (this.is_nullable(prop) && prefix) {
                        prop = "";
                    }
                    if (this.is_not_nullable(prop)) {
                        if (prefix) {
                            key = prefix + "[" + key + "]";
                        }
                        result.push(this.default_serializer(prop, key));
                    }
                }
            }
            else {
                if (this.is_not_nullable(value)) {
                    result.push(encodeURIComponent(prefix) + "=" + encodeURIComponent("" + value));
                }
            }
            return result.join("&");
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) &&
                    !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !object[this.configuration.special_options_key] &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) || result === false ? "" : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            // eslint-disable-next-line prefer-const
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {};
            for (const key in options) {
                const value = options[key];
                if (!hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            const query_parameters = {};
            for (const key in options) {
                if (!hasProp(options, key))
                    continue;
                const value = options[key];
                if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters, } = this.partition_parameters(parts, required_params, default_options, args);
            const missing_params = required_params.filter((param) => !hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (keyword_parameters.trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            result += keyword_parameters.anchor
                ? "#" + keyword_parameters.anchor
                : "";
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            return segment.replace(UriEncoderSegmentRegex, function (str) {
                return encodeURIComponent(str);
            });
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return "(" + this.build_path_spec(route[1]) + ")";
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                    break;
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return DeprecatedGlobbingBehavior ? result : encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        has_location() {
            return this.is_not_nullable(window) && !!window.location;
        }
        current_host() {
            if (this.has_location()) {
                return window.location.hostname;
            }
            else {
                return null;
            }
        }
        current_protocol() {
            if (this.has_location() && window.location.protocol !== "") {
                return window.location.protocol.replace(/:$/, "");
            }
            else {
                return "http";
            }
        }
        current_port() {
            if (this.has_location() && window.location.port !== "") {
                return window.location.port;
            }
            else {
                return "";
            }
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        namespace(object, namespace, routes) {
            const parts = (namespace === null || namespace === void 0 ? void 0 : namespace.split(".")) || [];
            if (parts.length === 0) {
                return routes;
            }
            for (let index = 0; index < parts.length; index++) {
                const part = parts[index];
                if (index < parts.length - 1) {
                    object = object[part] || (object[part] = {});
                }
                else {
                    return (object[part] = routes);
                }
            }
        }
        configure(new_config) {
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        is_module_supported(name) {
            return ModuleReferences[name].support();
        }
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        }
        define_module(name, module) {
            if (!name) {
                return;
            }
            this.ensure_module_supported(name);
            ModuleReferences[name].define(module);
        }
    }
    const Utils = new UtilsClass();
    // We want this helper name to be short
    const __jsr = {
        r(parts_table, route_spec, absolute) {
            return Utils.route(parts_table, route_spec, absolute);
        },
    };
    const result = {
        ...__jsr,
        configure: (config) => {
            return Utils.configure(config);
        },
        config: () => {
            return Utils.config();
        },
        serialize: (object) => {
            return Utils.serialize(object);
        },
        ...{},
    };
    Utils.namespace(Root, null, result);
    if ("ESM") {
        Utils.define_module("ESM", result);
    }
    return result;
})(this);
//# sourceMappingURL=routes.js.mapexport const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

/**
 * Generates rails route to
 * /checklist_documentos/abertura_regras_documentos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abertura_regras_documentos_checklist_documentos_path = __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"checklist_documentos"],[2,[7,"/"],[2,[6,"abertura_regras_documentos"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /processos_workflows/abertura_regras_documentos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abertura_regras_documentos_processos_workflows_path = __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"processos_workflows"],[2,[7,"/"],[2,[6,"abertura_regras_documentos"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /mudar_status_erros/acao_item(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const acao_item_mudar_status_erros_path = __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"mudar_status_erros"],[2,[7,"/"],[2,[6,"acao_item"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /tipos_assuntos_processos/:id/add_orgaos_blocked_by_assunto(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_orgaos_blocked_by_assunto_tipo_assunto_processo_path = __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"tipos_assuntos_processos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_orgaos_blocked_by_assunto"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /usuarios/:id/aprovar_cadastro(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aprovar_cadastro_usuario_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"usuarios"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"aprovar_cadastro"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /processos/assuntos/:tipo_id(.:format)
 * @param {any} tipo_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assuntos_processos_path = __jsr.r({"tipo_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"processos"],[2,[7,"/"],[2,[6,"assuntos"],[2,[7,"/"],[2,[3,"tipo_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tipos_assuntos_processos/:id/assuntos(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assuntos_tipo_assunto_processo_path = __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"tipos_assuntos_processos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"assuntos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /usuarios_manifestante/bloquear_desbloquear_acesso/:user_id(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bloquear_desbloquear_acesso_users_manifestantes_path = __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"usuarios_manifestante"],[2,[7,"/"],[2,[6,"bloquear_desbloquear_acesso"],[2,[7,"/"],[2,[3,"user_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /usuarios/:id/change_current_orgao(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const change_current_orgao_usuario_path = __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"usuarios"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"change_current_orgao"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /orgaos_processos/:id/change_orgao_protocolo_externo(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const change_orgao_protocolo_externo_orgao_processo_path = __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"orgaos_processos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"change_orgao_protocolo_externo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /change_show_number_status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const change_show_number_status_path = __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"change_show_number_status"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /usuarios/:id/change_status(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const change_status_usuario_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"usuarios"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"change_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /checklist_documentos/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checklist_documento_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"checklist_documentos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /checklist_documentos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checklist_documentos_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"checklist_documentos"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /usuarios/data_table(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_table_usuarios_path = __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"usuarios"],[2,[7,"/"],[2,[6,"data_table"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /notifications/deletar_ids(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deletar_ids_notifications_path = __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"deletar_ids"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /notifications/destroy_all(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_all_notifications_path = __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"destroy_all"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /tipos_assuntos_processos/:id/destroy_tipo(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_tipo_tipo_assunto_processo_path = __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"tipos_assuntos_processos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"destroy_tipo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /documentos/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const documento_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"documentos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /documentos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const documentos_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"documentos"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /processos/:id/documentos(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const documentos_processo_path = __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"processos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"documentos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /processos/documentos_processos_interessado/:processo_id(.:format)
 * @param {any} processo_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const documentos_processos_interessado_processos_path = __jsr.r({"processo_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"processos"],[2,[7,"/"],[2,[6,"documentos_processos_interessado"],[2,[7,"/"],[2,[3,"processo_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /processos/documentos_processos_internos/:processo_id(.:format)
 * @param {any} processo_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const documentos_processos_internos_processos_path = __jsr.r({"processo_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"processos"],[2,[7,"/"],[2,[6,"documentos_processos_internos"],[2,[7,"/"],[2,[3,"processo_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /processos/:id/editar(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_processo_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"processos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"editar"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /usuarios/:id/editar(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_usuario_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"usuarios"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"editar"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /usuarios_manifestante/editar_acesso/:user_id(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editar_acesso_users_manifestantes_path = __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"usuarios_manifestante"],[2,[7,"/"],[2,[6,"editar_acesso"],[2,[7,"/"],[2,[3,"user_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tipos_assuntos_processos/:id/editar_assunto(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editar_assunto_tipo_assunto_processo_path = __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"tipos_assuntos_processos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"editar_assunto"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tipos_assuntos_processos/:id/editar_tipo(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editar_tipo_tipo_assunto_processo_path = __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"tipos_assuntos_processos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"editar_tipo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /processos_workflows/get_tipos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_tipos_processos_workflows_path = __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"processos_workflows"],[2,[7,"/"],[2,[6,"get_tipos"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /usuarios_manifestante/lista/:user_id(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lista_users_manifestantes_path = __jsr.r({"user_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"usuarios_manifestante"],[2,[7,"/"],[2,[6,"lista"],[2,[7,"/"],[2,[3,"user_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /usuarios_manifestante/lista_usuarios/:user_id(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lista_usuarios_users_manifestantes_path = __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"usuarios_manifestante"],[2,[7,"/"],[2,[6,"lista_usuarios"],[2,[7,"/"],[2,[3,"user_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /lotacoes/orgaos_externos_ativos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lotacoes_orgaos_externos_ativos_path = __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"lotacoes"],[2,[7,"/"],[2,[6,"orgaos_externos_ativos"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /notifications/:id/marcar_lida(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const marcar_lida_notification_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"marcar_lida"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /usuarios/:id/multiusuarios_manifestante(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const multiusuarios_manifestante_usuario_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"usuarios"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"multiusuarios_manifestante"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /processos/novo(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_processo_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"processos"],[2,[7,"/"],[2,[6,"novo"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /usuarios/novo(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_usuario_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"usuarios"],[2,[7,"/"],[2,[6,"novo"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /notifications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notification_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /tipos_assuntos_processos/:id/orgaos_blocked_by_assunto(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orgaos_blocked_by_assunto_tipo_assunto_processo_path = __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"tipos_assuntos_processos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"orgaos_blocked_by_assunto"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /processos/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const processo_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"processos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /processos/:processo_id/movimentacoes/:movimentacao_id/spue_show(.:format)
 * @param {any} processo_id
 * @param {any} movimentacao_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const processo_movimentacao_spue_show_path = __jsr.r({"processo_id":{"r":true},"movimentacao_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"processos"],[2,[7,"/"],[2,[3,"processo_id"],[2,[7,"/"],[2,[6,"movimentacoes"],[2,[7,"/"],[2,[3,"movimentacao_id"],[2,[7,"/"],[2,[6,"spue_show"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /processos_workflows/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const processo_workflow_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"processos_workflows"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const processos_root_path = __jsr.r({}, [7,"/"]);

/**
 * Generates rails route to
 * /processos_workflows(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const processos_workflows_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"processos_workflows"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /orgaos_processos/:id/protocolos_ativos(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const protocolos_ativos_orgao_processo_path = __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"orgaos_processos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"protocolos_ativos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /documentos/remove_file_tmp(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remove_file_tmp_documentos_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"documentos"],[2,[7,"/"],[2,[6,"remove_file_tmp"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /tipos_assuntos_processos/:id/remove_orgaos_blocked_by_assunto(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remove_orgaos_blocked_by_assunto_tipo_assunto_processo_path = __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"tipos_assuntos_processos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_orgaos_blocked_by_assunto"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /usuarios/:id/resend_email_confirmation(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resend_email_confirmation_usuario_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"usuarios"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resend_email_confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /search_assunto_with_processo(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_assunto_with_processo_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"search_assunto_with_processo"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /processos/search_by_evento(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_by_evento_processos_path = __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"processos"],[2,[7,"/"],[2,[6,"search_by_evento"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /processos/search_by_numero(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_by_numero_processos_path = __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"processos"],[2,[7,"/"],[2,[6,"search_by_numero"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /services/search_cep/:cep(.:format)
 * @param {any} cep
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const services_search_cep_path = __jsr.r({"cep":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[6,"search_cep"],[2,[7,"/"],[2,[3,"cep"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /processos/:id/solicitacoes(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const solicitacoes_processo_path = __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"processos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"solicitacoes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /processos/:processo_id/movimentacoes/spue_index(.:format)
 * @param {any} processo_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spue_index_processo_movimentacoes_path = __jsr.r({"processo_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"processos"],[2,[7,"/"],[2,[3,"processo_id"],[2,[7,"/"],[2,[6,"movimentacoes"],[2,[7,"/"],[2,[6,"spue_index"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /telefones_setores/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const telefone_setor_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"telefones_setores"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /telefones_setores(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const telefones_setores_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"telefones_setores"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /usuarios_manifestante(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_manifestantes_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"usuarios_manifestante"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /usuarios/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usuario_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"usuarios"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /processos/usuario(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usuario_processos_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"processos"],[2,[7,"/"],[2,[6,"usuario"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /usuarios(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usuarios_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"usuarios"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /usuarios/:id/visitar_with(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const visitar_with_usuario_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"usuarios"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"visitar_with"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);